export enum NotificationTypeEnum {
  success = 'success',
  error = 'error',
  info = 'info',
}
